<template lang="pug">
div(
    :class="{ active: active }"
    class="full-page-loader"
)
    tl-loading-dots(
        class="dots"
        color="black"
        size="20"
    )
</template>

<script setup>
import { ref } from 'vue'
import { useEventBus } from '@vueuse/core'

const active = ref(false)
useEventBus('page-loader').on((val) => {
    active.value = val
})
</script>

<style lang="sass" scoped>
.full-page-loader
    width: 100vw
    height: 100vh
    position: fixed
    top: 0
    left: 0
    z-index: 120
    transition: all 0.5s ease-in-out
    opacity: 0
    pointer-events: none
    background-color: var(--color-white)
    display: flex
    justify-content: center
    align-items: center
    .dots
        transition: 0.3s ease-in-out
        transition-delay: 0s
        transform: translateY(50vh)
        opacity: 0
    &.active
        opacity: 1
        pointer-events: all
        .dots
            transition-delay: .4s
            transform: translateY(0)
            opacity: 1
</style>
